<wsb-modal (close)="activeModal.close()"
           (dismiss)="activeModal.dismiss()"
           cancelButtonEnable="true"
           primaryButtonText="{{ 'common_save' | translate }}"
           (primary)="save()"
           title="{{ 'sms_template_new' | translate }}"
           [primaryDisabled]="form.invalid"
           >
  <div body>
    <label for="sms_template_name" translate>common_title</label>
    <input type="text" id="sms_template_name"
           [formControl]="templateNameControl"
           class="form-control form-control--short"
           [ngClass]="{ 'is-invalid': templateNameControl.dirty && templateNameControl.invalid }" />
    <wsb-validation-error-msg [fc]="templateNameControl"></wsb-validation-error-msg>

    <label class="mt-2" translate>common_text</label>
    <wsb-sms-textarea #smsEditorView></wsb-sms-textarea>
  </div>
</wsb-modal>



